import { defineKey as T } from 'ha/i18n';

export const PAGE_SIZE = 20;

export const STATE_NAME = 'reservations';

export const TABLE_FILTERS = [
  {
    title: T('Move in date'),
    value: 'STARTDATE',
    col: 'description',
  },
  {
    title: T(`Tenant's name`),
    value: 'NAME',
    col: 'tenant',
  },
  {
    title: T('Monthly Rent'),
    value: 'PRICE',
    col: 'payment',
  },
];

export const ORDER_BY_OPTIONS = [
  {
    title: T('Address'),
    value: 'ADDRESS',
  },
  {
    title: T('Move in date'),
    value: 'STARTDATE',
  },
  {
    title: T('Move out date'),
    value: 'ENDDATE',
  },
  {
    title: T(`Tenant's name`),
    value: 'NAME',
  },
  {
    title: T('Monthly Rent'),
    value: 'PRICE',
  },
];

export const DEFAULT_PARAMS = {
  filter: null,
  orderBy: 'STARTDATE',
  isOrderDesc: true,
  history: false,
  page: 1,
};
